import BaseEnumType from "./base-enum-type";

const GameAccess = Object.freeze({
    GAME_CONFIG: new BaseEnumType("GAME_CONFIG", "GAME_CONFIG"),
    ADD_PLAYS: new BaseEnumType("ADD_PLAYS", "ADD_PLAYS"),
    FINALIZE: new BaseEnumType("FINALIZE", "FINALIZE"),
    VIEW_STATS: new BaseEnumType("VIEW_STATS", "VIEW_STATS"),
    HOME_TEAM_INFO: new BaseEnumType("HOME_TEAM_INFO", "HOME_TEAM_INFO"),
    AWAY_TEAM_INFO: new BaseEnumType("AWAY_TEAM_INFO", "AWAY_TEAM_INFO"),
    EVENT_INFO: new BaseEnumType("EVENT_INFO", "EVENT_INFO"),
    STREAM: new BaseEnumType("STREAM", "STREAM"),
    ALL: new BaseEnumType("ALL", "ALL")
});

export default GameAccess;
